import { Injectable } from '@angular/core';
import { BehaviorSubject,Observable,Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
/* *
this service is used to open the toast component 
@author suresh 15/10/2025
*/
private toastSubject=new BehaviorSubject<any>({})
getToast():Observable<any>{
  return this.toastSubject
}
  constructor() { }

  /* This Method is show the toast Success Message */ 

  success(message:any){
 
    this.toastSubject.next({severity:'success',summary:'Success',detail:message,icon:'badge-check'})
  }
  /* this Method is show the toast Info message */
  info(message:any){
    this.toastSubject.next({severity:'info',summary:'Info',detail:message,icon:'info'})

  }
  /* this Method is show the toast Warn message */

  warn(message:any){
    this.toastSubject.next({severity:'warn',summary:'Warn',detail:message,icon:'triangle-alert'})
  }
  /* this Method is show the  toast error message*/

  error(message:any){
    this.toastSubject.next({severity:'error',summary:'Error',detail:message,icon:'circle-x'})
  }
}
